// extracted by mini-css-extract-plugin
export var cardSelected = "_h7-2";
export var image = "_h7-1";
export var table = "_h7-0";